import React from "react";
import CreateContent from "./content/CreateContent";
import {useParams} from "react-router-dom";

const CreateShift = () => {
    const {id} = useParams();

    return (
        <CreateContent id={id} mode={id ? 'update' : 'add'} idGeneral="general-setting" idMidShift="midshift-seting"/>
    );
};

export default CreateShift;
